import { Typography } from "@spz/ui/components/typography";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../lib/utils";
import type { PieData } from "./pie-chart";

interface LegendItem {
  name: string;
  value: number;
}

interface PieChartDataLegendProps {
  data: PieData;
  className?: string;
}

const LegendItem: FC<LegendItem & { color: string; isEmpty: boolean }> = ({
  name,
  value,
  color,
  isEmpty,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between text-gray-900">
      <div className="flex items-center gap-2">
        <div
          style={{ backgroundColor: color }}
          className={cn("w-3 h-3 rounded-sm", color)}
        />
        <Typography className="text-size-sm">{t(name)}</Typography>
      </div>
      <Typography
        className={cn("font-title text-size-sm", isEmpty && "text-orange-900")}
      >
        {isEmpty ? "-" : `${value}%`}
      </Typography>
    </div>
  );
};

export const PieChartDataLegend: FC<PieChartDataLegendProps> = ({
  data,
  className,
}) => {
  const dataKeys = Object.keys(data);
  const isEmpty =
    dataKeys.length === 0 ||
    Object.values(data).every((item) => item.value === 0);

  return (
    <div className={cn("flex flex-col justify-center w-full gap-2", className)}>
      {dataKeys.map((key) => (
        <LegendItem
          key={key}
          name={key}
          value={data[key].value ?? 0}
          color={isEmpty ? "#E5E7EB" : data[key].color || "#9CA3AF"}
          isEmpty={isEmpty}
        />
      ))}
    </div>
  );
};
